import { render, staticRenderFns } from "./VolunteerRecommendation.vue?vue&type=template&id=2c825b97&scoped=true&"
import script from "./VolunteerRecommendation.vue?vue&type=script&lang=js&"
export * from "./VolunteerRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerRecommendation.vue?vue&type=style&index=0&id=2c825b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c825b97",
  null
  
)

export default component.exports